import { render, staticRenderFns } from "./RmaFileDrop.vue?vue&type=template&id=b0e79aa2&scoped=true"
import script from "./RmaFileDrop.vue?vue&type=script&lang=js"
export * from "./RmaFileDrop.vue?vue&type=script&lang=js"
import style0 from "./RmaFileDrop.vue?vue&type=style&index=0&id=b0e79aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e79aa2",
  null
  
)

export default component.exports